var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b, _c, _d, _e, _f, _g, _h;
import { FACTORY_ADDRESS as V3_FACTORY_ADDRESS } from '@uniswap/v3-sdk';
import { constructSameAddressMap } from '../utils/constructSameAddressMap';
import { SupportedChainId } from './chains';
export var UNI_ADDRESS = constructSameAddressMap('0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984');
export var MULTICALL_ADDRESS = __assign(__assign({}, constructSameAddressMap('0x1F98415757620B543A52E61c46B32eB19261F984', [
    SupportedChainId.OPTIMISTIC_KOVAN,
    SupportedChainId.OPTIMISM,
    SupportedChainId.POLYGON_MUMBAI,
    SupportedChainId.POLYGON,
])), (_a = {}, _a[SupportedChainId.ARBITRUM_ONE] = '0xadF885960B47eA2CD9B55E6DAc6B42b7Cb2806dB', _a[SupportedChainId.ARBITRUM_RINKEBY] = '0xa501c031958F579dB7676fF1CE78AD305794d579', _a));
export var V2_ROUTER_ADDRESS = constructSameAddressMap('0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D');
export var V3_ROUTER_ADDRESS = constructSameAddressMap('0xE592427A0AEce92De3Edee1F18E0157C05861564', [
    SupportedChainId.OPTIMISM,
    SupportedChainId.OPTIMISTIC_KOVAN,
    SupportedChainId.ARBITRUM_ONE,
    SupportedChainId.ARBITRUM_RINKEBY,
    SupportedChainId.ARBITRUM_GOERLI,
    SupportedChainId.POLYGON,
    SupportedChainId.POLYGON_MUMBAI,
]);
export var SWAP_ROUTER_ADDRESSES = constructSameAddressMap('0x68b3465833fb72A70ecDF485E0e4C7bD8665Fc45', [
    SupportedChainId.OPTIMISM,
    SupportedChainId.OPTIMISTIC_KOVAN,
    SupportedChainId.ARBITRUM_ONE,
    SupportedChainId.ARBITRUM_RINKEBY,
    SupportedChainId.ARBITRUM_GOERLI,
    SupportedChainId.POLYGON,
    SupportedChainId.POLYGON_MUMBAI,
]);
/**
 * The oldest V0 governance address
 */
export var GOVERNANCE_ALPHA_V0_ADDRESSES = constructSameAddressMap('0x5e4be8Bc9637f0EAA1A755019e06A68ce081D58F');
/**
 * The older V1 governance address
 */
export var GOVERNANCE_ALPHA_V1_ADDRESSES = (_b = {},
    _b[SupportedChainId.MAINNET] = '0xC4e172459f1E7939D522503B81AFAaC1014CE6F6',
    _b);
/**
 * The latest governor bravo that is currently admin of timelock
 */
export var GOVERNANCE_BRAVO_ADDRESSES = (_c = {},
    _c[SupportedChainId.MAINNET] = '0x408ED6354d4973f66138C91495F2f2FCbd8724C3',
    _c);
export var TIMELOCK_ADDRESS = constructSameAddressMap('0x1a9C8182C09F50C8318d769245beA52c32BE35BC');
export var MERKLE_DISTRIBUTOR_ADDRESS = (_d = {},
    _d[SupportedChainId.MAINNET] = '0x090D4613473dEE047c3f2706764f49E0821D256e',
    _d);
export var ARGENT_WALLET_DETECTOR_ADDRESS = (_e = {},
    _e[SupportedChainId.MAINNET] = '0xeca4B0bDBf7c55E9b7925919d03CbF8Dc82537E8',
    _e);
export var V3_CORE_FACTORY_ADDRESSES = constructSameAddressMap(V3_FACTORY_ADDRESS, [
    SupportedChainId.OPTIMISM,
    SupportedChainId.OPTIMISTIC_KOVAN,
    SupportedChainId.ARBITRUM_ONE,
    SupportedChainId.ARBITRUM_RINKEBY,
    SupportedChainId.ARBITRUM_GOERLI,
    SupportedChainId.POLYGON_MUMBAI,
    SupportedChainId.POLYGON,
]);
export var QUOTER_ADDRESSES = constructSameAddressMap('0xb27308f9F90D607463bb33eA1BeBb41C27CE5AB6', [
    SupportedChainId.OPTIMISM,
    SupportedChainId.OPTIMISTIC_KOVAN,
    SupportedChainId.ARBITRUM_ONE,
    SupportedChainId.ARBITRUM_RINKEBY,
    SupportedChainId.ARBITRUM_GOERLI,
    SupportedChainId.POLYGON_MUMBAI,
    SupportedChainId.POLYGON,
]);
export var NONFUNGIBLE_POSITION_MANAGER_ADDRESSES = constructSameAddressMap('0xC36442b4a4522E871399CD717aBDD847Ab11FE88', [
    SupportedChainId.OPTIMISM,
    SupportedChainId.OPTIMISTIC_KOVAN,
    SupportedChainId.ARBITRUM_ONE,
    SupportedChainId.ARBITRUM_RINKEBY,
    SupportedChainId.ARBITRUM_GOERLI,
    SupportedChainId.POLYGON_MUMBAI,
    SupportedChainId.POLYGON,
]);
export var ENS_REGISTRAR_ADDRESSES = (_f = {},
    _f[SupportedChainId.MAINNET] = '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e',
    _f[SupportedChainId.ROPSTEN] = '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e',
    _f[SupportedChainId.GOERLI] = '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e',
    _f[SupportedChainId.RINKEBY] = '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e',
    _f);
export var SOCKS_CONTROLLER_ADDRESSES = (_g = {},
    _g[SupportedChainId.MAINNET] = '0x65770b5283117639760beA3F867b69b3697a91dd',
    _g);
export var V3_MIGRATOR_ADDRESSES = constructSameAddressMap('0xA5644E29708357803b5A882D272c41cC0dF92B34', [
    SupportedChainId.ARBITRUM_ONE,
    SupportedChainId.ARBITRUM_RINKEBY,
    SupportedChainId.ARBITRUM_GOERLI,
    SupportedChainId.POLYGON_MUMBAI,
    SupportedChainId.POLYGON,
]);
export var TICK_LENS_ADDRESSES = (_h = {},
    _h[SupportedChainId.ARBITRUM_ONE] = '0xbfd8137f7d1516D3ea5cA83523914859ec47F573',
    _h[SupportedChainId.ARBITRUM_RINKEBY] = '0xbfd8137f7d1516D3ea5cA83523914859ec47F573',
    _h);
